import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const BicepIcon = memo(({ className }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: 'none' }}
  >
    <g clipPath="url(#clip0_6891_43532)">
      <path
        d="M15.1229 7.18801C15.5132 6.66883 15.7881 5.8811 15.1318 4.77113C14.4488 3.62535 9.51723 2.35425 9.02053 2.35425C7.84085 2.35425 5.41054 6.14964 5.22428 7.58187C4.16878 15.5576 1.89813 21.4924 2.39483 25.1714C2.65205 27.0601 2.67866 28.4566 3.68981 30.8555C4.53244 32.8517 9.46402 32.9591 12.4975 33.1918C16.3735 33.4962 20.8971 36.3606 27.8244 34.1765C36.5433 31.4284 35.1951 27.642 34.4235 25.5205C30.7337 15.4591 19.1675 12.4514 14.5464 21.8594C13.4022 24.1778 12.9942 24.2583 12.9942 24.2583C11.5395 17.133 9.54384 17.5537 10.6171 12.8542C10.6171 12.8542 13.5707 12.2277 14.7681 10.9028C15.4688 10.133 17.4557 8.19057 16.1695 7.34018C15.0963 6.63302 14.3867 7.81461 13.1982 8.12791"
        fill="#F0CBA7"
      />
      <g clipPath="url(#clip1_6891_43532)">
        <path
          d="M20.7197 5.17395C20.5423 3.93866 19.8949 3.28521 18.6708 3.10618C18.6087 3.09723 18.6087 3.01667 18.6708 3.00771C19.886 2.82869 20.5423 2.17523 20.7197 0.939939C20.7286 0.877279 20.8084 0.877279 20.8173 0.939939C20.9947 2.16628 21.6422 2.82869 22.8662 3.00771C22.9283 3.01667 22.9283 3.09723 22.8662 3.10618C21.6422 3.28521 20.9947 3.93866 20.8173 5.17395C20.8084 5.23661 20.7286 5.23661 20.7197 5.17395Z"
          fill="#226937"
        />
        <path
          d="M28.6847 15.9962C28.5162 13.7225 27.4164 12.6036 25.1635 12.4425C25.1368 12.4425 25.1368 12.3977 25.1635 12.3977C27.4164 12.2276 28.5251 11.1177 28.6847 8.84399C28.6847 8.81714 28.7291 8.81714 28.7291 8.84399C28.8976 11.1177 29.9975 12.2366 32.2504 12.3977C32.277 12.3977 32.277 12.4425 32.2504 12.4425C29.9975 12.6125 28.8887 13.7225 28.7291 15.9962C28.7291 16.023 28.6847 16.023 28.6847 15.9962Z"
          fill="#E9F0EB"
        />
        <path
          d="M30.6893 17.1777C30.4764 14.6176 29.2169 13.3465 26.6802 13.1317C26.6358 13.1317 26.6358 13.069 26.6802 13.069C29.2169 12.8542 30.4764 11.5831 30.6893 9.02301C30.6893 8.97825 30.7514 8.97825 30.7514 9.02301C30.9643 11.5831 32.2238 12.8542 34.7605 13.069C34.8049 13.069 34.8049 13.1317 34.7605 13.1317C32.2238 13.3465 30.9643 14.6176 30.7514 17.1777C30.7514 17.2225 30.6982 17.2225 30.6893 17.1777Z"
          fill="#226937"
        />
        <path d="M31.3064 13.099L30.7231 12.5104L30.1398 13.099L30.7231 13.6877L31.3064 13.099Z" fill="white" />
      </g>
      <path
        d="M13.349 5.39772C13.7393 4.87854 14.0142 4.09082 13.3579 2.98084C12.6749 1.83506 7.74331 0.563965 7.2466 0.563965C6.06693 0.563965 3.63662 4.35936 3.45035 5.79159C2.39485 13.7673 0.124201 19.7021 0.620906 23.3811C0.878129 25.2698 0.904738 26.6663 1.91589 29.0652C2.75851 31.0614 7.69009 31.1688 10.7235 31.4016C14.5996 31.7059 19.1232 34.5704 26.0505 32.3862C34.7694 29.6381 33.4212 25.8517 32.6495 23.7302C28.9597 13.6688 17.3936 10.6612 12.7725 20.0691C11.6283 22.3875 11.2202 22.4681 11.2202 22.4681C9.76561 15.3427 7.76992 15.7635 8.84316 11.064C8.84316 11.064 11.7968 10.4374 12.9942 9.11256C13.6949 8.34274 15.6817 6.40028 14.3956 5.5499C13.3224 4.84274 11.4686 6.30182 9.08264 7.00898C8.51498 7.17905 9.87205 5.04862 9.02942 4.74427"
        stroke="#EA7200"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6891_43532">
        <rect width="35" height="35" fill="white" />
      </clipPath>
      <clipPath id="clip1_6891_43532">
        <rect width="16.1695" height="16.3184" fill="white" transform="translate(18.6265 0.895142)" />
      </clipPath>
    </defs>
  </SvgIcon>
));
